import { Reducer } from 'redux';
import { deepEquals } from 'app/infrastructure/js';
import { CodetableOptions } from './types';
import {
  ACTION, RequestCodetable, ReceiveCodetable, FailCodetable
} from './action-types';

interface CodetableItemState {
  codetableOptions: { [key: string]: CodetableOptions };
}

export const reducers: { [indexer: string]: Reducer<CodetableItemState> } = {

  [ACTION.REQUEST_CODETABLE]: (state: CodetableItemState, action: RequestCodetable): CodetableItemState => {
    return {
      ...state,
      codetableOptions: {
        ...(state.codetableOptions || {}),
        [action.id]: {
          fetching: true,
          loadOptionsParams: action.loadOptionsParams,
          codes: undefined,
          currentOptions: undefined
        }
      }
    };
  },

  [ACTION.RECEIVE_CODETABLE]: (state: CodetableItemState, action: ReceiveCodetable): CodetableItemState => {

    if (!state.codetableOptions || !state.codetableOptions[action.id] ||
      !deepEquals(state.codetableOptions[action.id].loadOptionsParams, action.loadOptionsParams)) {
      return state;
    }

    return {
      ...state,
      codetableOptions: {
        ...state.codetableOptions,
        [action.id]: {
          ...state.codetableOptions[action.id],
          fetching: false,
          codes: action.codes,
          currentOptions: action.currentOptions
        }
      }
    };
  },

  [ACTION.FAIL_CODETABLE]: (state: CodetableItemState, action: FailCodetable): CodetableItemState => {

    if (!state.codetableOptions || !state.codetableOptions[action.id] ||
      !deepEquals(state.codetableOptions[action.id].loadOptionsParams, action.loadOptionsParams)) {
      return state;
    }

    return {
      ...state,
      codetableOptions: {
        ...state.codetableOptions,
        [action.id]: {
          ...state.codetableOptions[action.id],
          fetching: false
        }
      }
    };
  }
};
